//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { execQuery, contentAPIMixin } from '~/mixins/contentApi'
import makeQuery from '~/gql/sidebar.gql.js'

export default {
  name: 'DynamicSidebar',
  mixins: [contentAPIMixin],
  data: () => ({
    title: null,
    body: '',
    updatedAt: null,
    slug: null,
    meta: {}
  }),
  async fetch () {
    if (!this.activeSlug) return
    const gqlQuery = makeQuery(this.activeSlug)
    const result = await execQuery(this, gqlQuery, true)
    this.query = gqlQuery
    this.onUpdate({ response: { data: result } })
  },
  computed: {
    ...mapGetters({
      visible: 'sidebar/open',
      activeSlug: 'sidebar/slug'
    }),
    showLastUpdate () {
      return ['terms-and-conditions', 'privacy-policy'].includes(this.slug)
    }
  },
  watch: {
    activeSlug () {
      if (this.activeSlug) {
        this.body = ''
        this.title = null
        this.updatedAt = null
        this.slug = null
        this.$fetch()
      }
    }
  },
  created () {
    if (this.$route.path.includes('/info/') && (this.$route.params.slug || this.$route.meta.slug)) {
      this.$store.dispatch('sidebar/OPEN_SIDEBAR_PAGE', { slug: (this.$route.params.slug || this.$route.meta.slug) })
    }
  },
  mounted () {
    this.addURLListener()
  },
  beforeDestroy () {
    this.removeURLListener()
  },
  methods: {
    close (alterHistory = true) {
      if (alterHistory) this.$store.dispatch('sidebar/CLOSE_SIDEBAR_PAGE')
      else this.$store.commit('sidebar/CLOSE_SIDEBAR')
    },
    addURLListener () {
      window.addEventListener('popstate', this.URLListener)
    },
    removeURLListener () {
      window.removeEventListener('popstate', this.URLListener)
    },
    URLListener () {
      const urlPaths = window.location.pathname.split('/')
      const isInfoPage = (urlPaths[0] === 'info' || (!!urlPaths[1] && urlPaths[1] === 'info'))
      
      if (isInfoPage && !this.visible) {
        const matches = [...window.location.pathname.matchAll(/\/info\/(.+)\/?$/g)]
        if (!matches.length) return
        const slug = matches[0][1]
        this.$store.commit('sidebar/OPEN_SIDEBAR', { slug })
      } else {
        this.close(false)
      }
    }
  }
}
